// Routes.js
const Routes = {
    dashboard: {
        main: '/',
    },
    sendAndRequest: {
        main: '/send-and-request',
        sendMoney: '/send-and-request/send-money',
        sendMoneyForm: '/send-money-form/:id',
        requestMoney: '/send-and-request/request-money',
        requestMoneyForm: '/request-money-form/:id',
        requestMoneyTransactionDetails: '/request-money/transaction-detail/:transactionId',
    },

    staff: {
        main: '/staff',
        details: '/staff/:username',
        detailsEdit: '/staff/details-edit',
        add: '/staff/add',
    },
    account: {
        main: '/my-account',
        edit: '/my-account/edit',
        changePhoto: '/my-account/change-photo',
        changePassword: '/my-account/change-password',
        businessChangePhoto: '/business-profile/change-photo',
        paymentTokenDetail: '/payment-token-detail/:id',
    },
    sendinvoice: {
        main: '/send-invoice',
    },
    sendmoney: {
        main: '/send-money',
    },
    auth: {
        login: '/login',
        forgotPassword: '/auth/forgot-Password',
        verifyPin: '/auth/verify-pin',
        changePassword: '/auth/change-password',
        verifyTempPassword: '/auth/verity-temp-password',
    },
    qr: {
        main: '/qr/view-qr',
    },
    user: {
        userDetail: `/user/:username`,
    },
    transactions: {
        transactionDetails: '/transaction-detail/:transactionId',
    },
    export_CSV_file: {
        exportCSV: '/export-csv-file',
    },
};

export default Routes;
